/* import __COLOCATED_TEMPLATE__ from './group-activity-filter.hbs'; */
import Component from "@ember/component";
export default Component.extend({
  tagName: "li",
});
